import { GooglePayAction, GooglePayActionType } from '../actions/googlePay';
import { GooglePayNamespace } from '../state/googlePay';

export const googlePayReducer = (
    state: GooglePayNamespace = {
        googlePayPaymentRequest: null,
        googlePayInstance: null,
        isLoadingGooglePay: false,
    },
    action: GooglePayAction,
): GooglePayNamespace => {
    switch (action.type) {
        case GooglePayActionType.setGooglePayInstance:
        case GooglePayActionType.setGooglePayPaymentRequest:
        case GooglePayActionType.setIsLoadingGooglePay:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
